/* DogLove Pro buy box. Drives Dawn's hidden variant picker so the theme, cart and Bundlex keep working. */
(function () {
  function start() {
    var root = document.getElementById('dlp-buybox');
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    var dataEl = document.getElementById('dlpb-data');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var info = root.closest('product-info') || document.querySelector('product-info');
    if (!info) return;

    var SIZES = [
      {k:'XS', name:'Extra small', min:33, max:43, dog:'Chihuahua'},
      {k:'S', name:'Small', min:43, max:56, dog:'Mini Dachshund'},
      {k:'M', name:'Medium', min:56, max:69, dog:'Beagle'},
      {k:'L', name:'Large', min:69, max:81, dog:'Labrador'},
      {k:'XL', name:'Extra large', min:81, max:107, dog:'Great Dane'}
    ];
    var NEAR_TOP_CM = 5;
    var PREVIEW_SIZE = 'S';
    var SWATCH = {
      'Teal':'#1E9AAE','Electric Pink':'#E0409A','Black':'#1C1C20','Hot Green':'#7CC242','Grey':'#8A9096','Royal Blue':'#2F55B4','Red':'#D23B3B','Purple':'#6A3F99',
      'Orange':'linear-gradient(135deg,#F07C2A 0 60%,#1C1C20 60% 100%)','Brown':'#7A5230',
      'Camouflage Blue':'linear-gradient(135deg,#9CC3E4 0 28%,#5B86B5 28% 65%,#2E4F7A 65%)',
      'Saxony Blue':'repeating-linear-gradient(135deg,#B9D3E6 0 6px,#4E6F8F 6px 12px)',
      'Navy Blazer':'radial-gradient(circle at 32% 36%,#E48FB0 0 12%,transparent 13%),radial-gradient(circle at 66% 62%,#F2C14E 0 10%,transparent 11%),#1D2A4D'
    };
    var FIT_BASE = 'https://cdn.shopify.com/s/files/1/0058/7268/1024/files/';
    var FIT_OVERRIDE = {
      'XS|Camouflage Blue':'small-chihuahua-camouflage-blue.webp',
      'M|Camouflage Blue':'medium-beagle-camouflage-blue.webp',
      'L|Camouflage Blue':'large-labrador-camouflage-blue.webp',
      'XL|Camouflage Blue':'xlarge-great-dane-camouflage-blue.webp'
    };
    var FREE_SHIP_CENTS = 7900; /* Australia Standard is free from $79 (Shipping settings) */
    var AFTERPAY_LOGO = 'https://cdn.shopify.com/s/files/1/0058/7268/1024/files/download_7_430x.png?v=1771566325';

    function el(id) { return document.getElementById(id); }
    function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    function byKey(k) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].k === k) return SIZES[i]; return null; }

    var map = {}, colours = [], sizePrice = {}, minPrice = null, anyAvailable = false;
    data.variants.forEach(function (v) {
      var size = v.options[data.sizeIndex], colour = v.options[data.colourIndex];
      map[size + '|' + colour] = v;
      if (colours.indexOf(colour) < 0) colours.push(colour);
      if (typeof sizePrice[size] !== 'number') sizePrice[size] = v.price;
      if (v.available) { anyAvailable = true; if (minPrice === null || v.price < minPrice) minPrice = v.price; }
    });
    if (minPrice === null) minPrice = data.variants.length ? data.variants[0].price : 0;
    function variant(size, colour) { return map[size + '|' + colour] || null; }
    function sizeHasStock(size) { return colours.some(function (c) { var v = variant(size, c); return v && v.available; }); }

    /* Lead in the Bundlex offer: 110cm first, colour picked to go with the harness, width by harness size, only in stock */
    var LEAD_ALIAS = {'Electric Pink':'Pink', 'Saxony Blue':'Brown', 'Navy Blazer':'Brown', 'Camouflage Blue':'Red'};
    var LEAD_FALLBACK_COLOUR = 'Black';
    var leadStock = {};
    (data.lead || []).forEach(function (v) { if (v && v.options && v.options.length > 1) leadStock[v.options[0] + '|' + v.options[1]] = !!v.available; });
    var hasLeadData = Object.keys(leadStock).length > 0;
    var leadTouched = false;
    var autoNote = ''; /* set when a chosen size is sold out in the current colour and we move to one in stock */

    var initialView = document.querySelector('.dlpb-view.is-active') || document.querySelector('.dlpb-view[data-view="detail"]');
    var state = { selected:null, colour:colours.indexOf('Teal') > -1 ? 'Teal' : colours[0], cm:null, view:initialView ? initialView.getAttribute('data-view') : 'dog' };
    if (data.selected) {
      data.variants.forEach(function (v) {
        if (String(v.id) === String(data.selected)) { state.selected = v.options[data.sizeIndex]; state.colour = v.options[data.colourIndex]; }
      });
    }

    var cmInput = el('dlpb-cm'), recEl = el('dlpb-rec'), sizesWrap = el('dlpb-sizes'), swWrap = el('dlpb-swatches');
    var priceEl = el('dlpb-price'), stockEl = el('dlpb-stock'), afterpayEl = el('dlpb-afterpay'), colourNameEl = el('dlpb-colour-name');
    var summaryEl = el('dlpb-summary'), summaryText = el('dlpb-summary-text'), summaryPrice = el('dlpb-summary-price'), saveEl = el('dlpb-save'), shipEl = el('dlpb-ship');
    var upsellEl = el('dlpb-upsell'), upsellMain = el('dlpb-upsell-main'), upsellSub = el('dlpb-upsell-sub');
    var photo = el('dlpb-photo'), badge = el('dlpb-badge'), sticky = el('dlpb-sticky'), stickyBtn = el('dlpb-sticky-btn');
    var HERO_URL = photo.getAttribute('data-hero'), HERO_COLOUR = photo.getAttribute('data-hero-colour') || 'Teal', viewTouched = false;

    /* Size buttons and swatches */
    var sizeButtons = SIZES.map(function (s) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'dlpb-size'; b.textContent = s.k; b.setAttribute('data-size', s.k);
      b.addEventListener('click', function () { chooseSize(s.k, true); });
      sizesWrap.appendChild(b);
      return b;
    });
    var swatches = colours.map(function (c) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'dlpb-swatch'; b.setAttribute('role', 'radio'); b.setAttribute('aria-label', c); b.title = c;
      b.style.background = SWATCH[c] || '#C9CFCF';
      b.addEventListener('click', function () { state.colour = c; autoNote = ''; render(); if (state.selected) syncNative(); });
      b.addEventListener('mouseenter', function () { preload(c); });
      swWrap.appendChild(b);
      b.dlpbColour = c;
      return b;
    });

    /* Measurement */
    function measure(v) {
      if (v === null) return {state:'empty'};
      if (v < 33) return {state:'small'};
      if (v > 107) return {state:'large'};
      for (var i = 0; i < SIZES.length; i++) {
        var s = SIZES[i], last = i === SIZES.length - 1;
        if (v >= s.min && (v < s.max || (last && v <= s.max))) {
          var r = {state:'ok', size:s};
          if (i > 0 && v === s.min) r.boundary = SIZES[i - 1];
          else if (!last && v >= s.max - NEAR_TOP_CM) r.near = SIZES[i + 1];
          return r;
        }
      }
      return {state:'empty'};
    }
    var measureTimer = null;
    function readCm() {
      var raw = String(cmInput.value || '').trim();
      if (!raw) return null;
      var v = Math.round(parseFloat(raw));
      return isFinite(v) ? v : null;
    }
    function onMeasure(final) {
      var v = readCm();
      if (!final && v !== null && v < 20) return;
      state.cm = v;
      var m = measure(v);
      if (m.state === 'ok') { chooseSize(m.size.k, false); return; }
      if ((m.state === 'small' || m.state === 'large') && state.selected) {
        state.selected = null;
        render();
        syncNative();
        dropVariantFromUrl();
        return;
      }
      render();
    }
    cmInput.addEventListener('input', function () {
      if (measureTimer) clearTimeout(measureTimer);
      measureTimer = setTimeout(function () { onMeasure(false); }, 350);
    });
    cmInput.addEventListener('change', function () { if (measureTimer) clearTimeout(measureTimer); onMeasure(true); });

    function chooseSize(k, fromButton) {
      if (fromButton) { state.cm = null; cmInput.value = ''; }
      state.selected = k;
      autoNote = '';
      var cur = variant(k, state.colour);
      if ((!cur || !cur.available) && sizeHasStock(k)) {
        var from = state.colour;
        for (var i = 0; i < colours.length; i++) { var x = variant(k, colours[i]); if (x && x.available) { state.colour = colours[i]; break; } }
        autoNote = from + ' is sold out in ' + k + ' right now, so we have switched you to ' + state.colour + '. Tap any colour to change it.';
      }
      render();
      syncNative();
    }

    /* Gallery */
    function fitImage(size, colour) {
      var o = FIT_OVERRIDE[size + '|' + colour];
      return FIT_BASE + (o ? o : 'dlp-dog-' + size.toLowerCase() + '-' + slug(colour) + '-v3.webp');
    }
    function detailImage(colour) {
      var v = state.selected ? variant(state.selected, colour) : null;
      if (!v || !v.image) { v = null; data.variants.some(function (x) { if (x.options[data.colourIndex] === colour && x.image) { v = x; return true; } return false; }); }
      return v && v.image ? v.image : null;
    }
    function preload(colour) {
      var img = new Image();
      img.src = state.view === 'dog' ? fitImage(state.selected || PREVIEW_SIZE, colour) : (detailImage(colour) || '');
    }
    var photoTicket = 0;
    function updatePhoto() {
      var size = state.selected || PREVIEW_SIZE;
      var dog = state.view === 'dog';
      var hero = !viewTouched && HERO_URL && state.colour === HERO_COLOUR;
      var url = hero ? HERO_URL : (dog ? fitImage(size, state.colour) : detailImage(state.colour));
      var alt = hero ? (photo.getAttribute('data-hero-alt') || 'DogLove Pro harness in ' + state.colour) : (dog ? (byKey(size).dog + ' wearing the ' + state.colour + ' DogLove Pro harness, size ' + size) : ('DogLove Pro harness in ' + state.colour));
      badge.textContent = hero ? (photo.getAttribute('data-hero-badge') || state.colour) : ((dog ? 'Shown on a dog · ' : 'Harness detail · ') + state.colour);
      Array.prototype.forEach.call(document.querySelectorAll('.dlpb-view'), function (x) {
        var on = !hero && x.getAttribute('data-view') === state.view; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (!url || photo.getAttribute('data-src') === url) return;
      var ticket = ++photoTicket;
      photo.classList.add('is-changing');
      var loader = new Image();
      loader.onload = function () {
        if (ticket !== photoTicket) return;
        photo.src = url; photo.alt = alt; photo.setAttribute('data-src', url);
        photo.classList.remove('is-changing');
      };
      loader.onerror = function () { if (ticket === photoTicket) photo.classList.remove('is-changing'); };
      loader.src = url;
    }
    Array.prototype.forEach.call(document.querySelectorAll('.dlpb-view'), function (b) {
      b.addEventListener('click', function () {
        viewTouched = true;
        state.view = b.getAttribute('data-view');
        Array.prototype.forEach.call(document.querySelectorAll('.dlpb-view'), function (x) {
          var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        updatePhoto();
      });
    });

    /* How to measure */
    var measureToggle = el('dlpb-measure-toggle'), measurePanel = el('dlpb-measure');
    measureToggle.addEventListener('click', function () {
      var open = measureToggle.getAttribute('aria-expanded') === 'true';
      measureToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      measurePanel.hidden = open;
    });

    /* Size by weight, for dogs without a tape measure handy */
    var weightToggle = el('dlpb-weight-toggle'), weightPanel = el('dlpb-weight');
    var weightRows = weightPanel ? Array.prototype.slice.call(weightPanel.querySelectorAll('.dlpb-weight-row')) : [];
    if (weightToggle && weightPanel) weightToggle.addEventListener('click', function () {
      var open = weightToggle.getAttribute('aria-expanded') === 'true';
      weightToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      weightPanel.hidden = open;
      info.classList.toggle('dlpb-weight-open', !open);
    });
    weightRows.forEach(function (r) {
      r.addEventListener('click', function () {
        var k = r.getAttribute('data-size');
        if (byKey(k)) chooseSize(k, true);
      });
    });

    /* Bundlex offer awareness */
    function bundleWidget() { return info.querySelector('.bx-widget'); }
    function activeOffer() {
      var w = bundleWidget();
      if (!w || !state.selected) return null;
      var offers = Array.prototype.slice.call(w.querySelectorAll('.js-bx-offer'));
      var active = w.querySelector('.js-bx-offer.bx-active');
      if (!active) return null;
      var priceNode = active.querySelector('.js-bx-offer-price .bx-discounted-price') || active.querySelector('.js-bx-offer-price');
      var origNode = active.querySelector('.js-bx-offer-price .bx-original-price');
      return { index: offers.indexOf(active), cents: parseCents(priceNode), original: parseCents(origNode), node: active };
    }
    function parseCents(node) {
      if (!node) return null;
      var n = parseFloat(String(node.textContent).replace(/[^0-9.]/g, ''));
      return isFinite(n) ? Math.round(n * 100) : null;
    }
    function optionValues(select) { return Array.prototype.map.call(select.options || [], function (o) { return o.value; }); }
    function leadPairs(scope) {
      scope = scope || bundleWidget();
      if (!scope) return [];
      var groups = {}, keys = [];
      Array.prototype.forEach.call(scope.querySelectorAll('.js-bx-extra-select'), function (s) {
        var key = (s.getAttribute('data-offer-key') || '') + '|' + (s.getAttribute('data-extra-uuid') || '');
        if (!groups[key]) { groups[key] = {}; keys.push(key); }
        var isLength = optionValues(s).some(function (v) { return /\d\s*cm\)?\s*$/i.test(v); });
        if (isLength) groups[key].size = s; else groups[key].colour = s;
      });
      return keys.map(function (k) { return groups[k]; }).filter(function (g) { return g.size && g.colour; });
    }
    function pickLead(sizeValues, colourValues) {
      if (!hasLeadData || !state.selected) return null;
      var widths = (state.selected === 'L' || state.selected === 'XL') ? ['L/XL', 'S/M'] : ['S/M', 'L/XL'];
      var lengths = ['110cm', '200cm'];
      var match = LEAD_ALIAS[state.colour] || state.colour;
      var tryColours = [];
      if (colourValues.indexOf(match) > -1) tryColours.push(match);
      if (colourValues.indexOf(LEAD_FALLBACK_COLOUR) > -1 && tryColours.indexOf(LEAD_FALLBACK_COLOUR) < 0) tryColours.push(LEAD_FALLBACK_COLOUR);
      for (var c = 0; c < tryColours.length; c++) {
        for (var l = 0; l < lengths.length; l++) {
          for (var w = 0; w < widths.length; w++) {
            for (var i = 0; i < sizeValues.length; i++) {
              var sv = sizeValues[i];
              if (sv.indexOf(widths[w]) === 0 && sv.replace(/\s/g, '').indexOf(lengths[l]) > -1 && leadStock[sv + '|' + tryColours[c]]) return {size: sv, colour: tryColours[c]};
            }
          }
        }
      }
      return null;
    }
    /* With only the harness picked, show what the lead would add, read straight from the Bundlex offer */
    function bundleUpsell(harnessCents) {
      var w = bundleWidget();
      if (!w) return null;
      var offers = w.querySelectorAll('.js-bx-offer');
      for (var i = 1; i < offers.length; i++) {
        var o = offers[i];
        var disc = parseCents(o.querySelector('.js-bx-offer-price .bx-discounted-price'));
        var orig = parseCents(o.querySelector('.js-bx-offer-price .bx-original-price'));
        if (!disc || !orig || orig <= disc || disc <= harnessCents) continue;
        var pair = leadPairs(o)[0];
        return {node:o, add:disc - harnessCents, save:orig - disc, total:disc, colour:pair ? pair.colour.value : ''};
      }
      return null;
    }
    function applyLead() {
      if (leadTouched || !state.selected) return;
      leadPairs().forEach(function (g) {
        var pick = pickLead(optionValues(g.size), optionValues(g.colour));
        if (!pick) return;
        var changed = [];
        if (g.colour.value !== pick.colour) { g.colour.value = pick.colour; changed.push(g.colour); }
        if (g.size.value !== pick.size) { g.size.value = pick.size; changed.push(g.size); }
        changed.forEach(fire);
      });
    }

    /* Native Dawn controls */
    function nativeScope() { return info.querySelector('variant-selects') || info.querySelector('variant-radios'); }
    function nameMatches(actual, expected) {
      actual = String(actual || '');
      return actual === expected || actual.indexOf(expected + '-') === 0 || actual === 'options[' + expected + ']';
    }
    function findRadio(scope, opt, value) {
      if (!scope) return null;
      var inputs = scope.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) if (nameMatches(inputs[i].name, opt) && inputs[i].value === value) return inputs[i];
      return null;
    }
    function findSelect(scope, opt) {
      if (!scope) return null;
      var sels = scope.querySelectorAll('select');
      for (var i = 0; i < sels.length; i++) if (nameMatches(sels[i].name, opt)) return sels[i];
      return null;
    }
    function setOption(scope, opt, value) {
      var radio = findRadio(scope, opt, value);
      if (radio) { if (radio.checked) return null; radio.checked = true; return radio; }
      var select = findSelect(scope, opt);
      if (!select || select.value === value) return null;
      for (var i = 0; i < select.options.length; i++) if (select.options[i].value === value) { select.value = value; return select; }
      return null;
    }
    function clearNativeSize() {
      var scope = nativeScope();
      if (!scope) return;
      Array.prototype.forEach.call(scope.querySelectorAll('input[type="radio"]'), function (r) {
        if (nameMatches(r.name, data.sizeOption) && byKey(r.value)) r.checked = false;
      });
      var select = findSelect(scope, data.sizeOption);
      if (select) select.selectedIndex = -1;
    }
    function fire(node) {
      var ev;
      try { ev = new Event('change', {bubbles:true}); } catch (err) { ev = document.createEvent('Event'); ev.initEvent('change', true, true); }
      node.dispatchEvent(ev);
    }
    function writeFormId(v) {
      if (!v) return;
      Array.prototype.forEach.call(info.querySelectorAll('form[action*="/cart/add"] input[name="id"]'), function (field) {
        var id = String(v.id);
        if (field.value !== id) field.value = id;
      });
    }
    var syncing = false, syncTimer = null;
    function syncNative() {
      if (syncTimer) clearTimeout(syncTimer);
      syncTimer = setTimeout(doSync, 15);
    }
    function doSync() {
      syncTimer = null;
      var scope = nativeScope();
      syncing = true;
      var changed = [];
      if (scope) {
        if (!state.selected) clearNativeSize();
        else {
          var a = setOption(scope, data.sizeOption, state.selected);
          var b = setOption(scope, data.colourOption, state.colour);
          if (a) changed.push(a);
          if (b) changed.push(b);
        }
      }
      if (changed.length) fire(changed[changed.length - 1]);
      syncBundleSelects();
      if (state.selected) writeFormId(variant(state.selected, state.colour));
      setTimeout(function () { syncing = false; gate(); }, 40);
    }
    function selectKind(select) {
      var values = Array.prototype.map.call(select.options || [], function (o) { return o.value; });
      if (SIZES.filter(function (s) { return values.indexOf(s.k) > -1; }).length >= 4) return 'size';
      if (colours.filter(function (c) { return values.indexOf(c) > -1; }).length >= 5) return 'colour';
      return null;
    }
    function syncBundleSelects() {
      if (!state.selected) return;
      var changed = [];
      Array.prototype.forEach.call(document.querySelectorAll('select'), function (select) {
        if (root.contains(select) || (select.closest && select.closest('variant-selects'))) return;
        if (select.classList && select.classList.contains('js-bx-extra-select')) return;
        var kind = selectKind(select);
        var wanted = kind === 'size' ? state.selected : (kind === 'colour' ? state.colour : null);
        if (!wanted || select.value === wanted) return;
        if (!Array.prototype.some.call(select.options, function (o) { return o.value === wanted; })) return;
        select.value = wanted;
        changed.push(select);
      });
      changed.forEach(fire);
      applyLead();
    }

    /* Only a real shopper can change the size from outside the buy box. Apps that push a default size on load are ignored. */
    var lastUserAction = 0;
    ['click', 'change', 'input', 'keydown'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        if (!e.isTrusted || !e.target || e.target.nodeType !== 1 || !e.target.closest) return;
        if (e.target.closest('.bx-widget-container, variant-selects, variant-radios, #Avada-CartSticky-Bar')) lastUserAction = Date.now();
      }, true);
    });
    function controlKind(node) {
      if (node.tagName === 'SELECT') return selectKind(node);
      var d = ((node.name || '') + ' ' + (node.id || '')).toLowerCase();
      if (d.indexOf('size') > -1 || byKey(node.value)) return 'size';
      if (d.indexOf('color') > -1 || d.indexOf('colour') > -1 || colours.indexOf(node.value) > -1) return 'colour';
      return null;
    }
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (t && t.classList && t.classList.contains('js-bx-extra-select')) {
        /* The lead has its own size and colour. A shopper picking them never changes the harness. */
        if (event.isTrusted) leadTouched = true;
        setTimeout(render, 0);
        return;
      }
      if (!t || root.contains(t) || syncing) return;
      var kind = controlKind(t);
      if (!kind) return;
      var value = t.value;
      var inNative = !!(t.closest && t.closest('variant-selects, variant-radios'));
      var differs = (kind === 'size' && byKey(value) && value !== state.selected) || (kind === 'colour' && colours.indexOf(value) > -1 && value !== state.colour);
      if (!differs) return;
      if (!event.isTrusted && inNative && Date.now() - lastUserAction > 2000) {
        event.stopImmediatePropagation();
        var scope = nativeScope();
        if (state.selected) setOption(scope, data.sizeOption, state.selected); else clearNativeSize();
        setOption(scope, data.colourOption, state.colour);
        gate();
        return;
      }
      if (kind === 'size') { state.selected = value; state.cm = null; cmInput.value = ''; autoNote = ''; }
      else state.colour = value;
      if (inNative) {
        var scopeNow = nativeScope();
        var checked = scopeNow ? Array.prototype.filter.call(scopeNow.querySelectorAll('input[type="radio"]:checked'), function () { return true; }) : [];
        checked.forEach(function (r) {
          if (nameMatches(r.name, data.sizeOption) && byKey(r.value)) state.selected = r.value;
          if (nameMatches(r.name, data.colourOption) && colours.indexOf(r.value) > -1) state.colour = r.value;
        });
      }
      render();
      syncNative();
    }, true);

    /* Dawn button, gating and sticky bar */
    function submitButton() { return info.querySelector('.product-form__submit'); }
    function labelSpan(btn) { return btn.querySelector('span:not(.loading__spinner):not(.sold-out-message)'); }
    function currentLabel() {
      if (!state.selected) return {text:'Choose a size', disabled:true};
      var v = variant(state.selected, state.colour);
      if (!v) return {text:'Not available', disabled:true};
      if (!v.available) return {text:state.selected + ' in ' + state.colour + ' is sold out', disabled:true};
      var offer = activeOffer();
      if (offer && offer.index > 0 && offer.cents !== null) return {text:'Add bundle to cart · ' + money(offer.cents), disabled:false, cents:offer.cents, bundle:true, original:offer.original, offerNode:offer.node};
      return {text:'Add ' + state.selected + ' in ' + state.colour + ' to cart · ' + money(v.price), disabled:false, cents:v.price};
    }
    var applyingLabel = false;
    function gate() {
      var waiting = !state.selected;
      info.classList.toggle('dlp-awaiting-size', waiting);
      document.documentElement.classList.toggle('dlp-awaiting-size', waiting);
      var btn = submitButton();
      var l = currentLabel();
      if (btn) {
        applyingLabel = true;
        if (btn.disabled !== l.disabled) btn.disabled = l.disabled;
        if (l.disabled) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
        var span = labelSpan(btn);
        if (span) { if (span.textContent.trim() !== l.text) span.textContent = l.text; }
        else if (btn.textContent.trim() !== l.text) btn.textContent = l.text;
        applyingLabel = false;
      }
      if (state.selected) writeFormId(variant(state.selected, state.colour));
      if (stickyBtn) {
        stickyBtn.textContent = state.selected ? (l.disabled ? 'Pick another colour' : l.text) : 'Choose your size';
        stickyBtn.classList.toggle('is-muted', !state.selected || l.disabled);
      }
    }

    function render() {
      var s = state.selected ? byKey(state.selected) : null;
      var v = s ? variant(s.k, state.colour) : null;
      var m = measure(state.cm);

      /* price and stock */
      var cents = v ? v.price : (s ? sizePrice[s.k] : minPrice);
      priceEl.textContent = s ? money(cents) : 'From ' + money(minPrice);
      var inStock = s ? !!(v && v.available) : anyAvailable;
      stockEl.textContent = inStock ? 'In stock' : 'Sold out';
      stockEl.classList.toggle('is-out', !inStock);
      var quarter = Math.round((s ? cents : minPrice) / 4);
      afterpayEl.innerHTML = 'or 4 payments ' + (s ? 'of' : 'from') + ' <strong>' + money(quarter) + '</strong> with<img src="' + AFTERPAY_LOGO + '" alt="Afterpay" width="70" height="14" loading="lazy">';

      /* recommendation */
      var rec = '';
      var HELP = '<small>Still unsure? <a href="/pages/contact-us">Send us a photo</a> and we will help you choose.</small>';
      if (m.state === 'ok') {
        rec = '<strong>Your size: ' + m.size.k + '</strong> · Fits ' + m.size.min + ' to ' + m.size.max + ' cm';
        if (m.boundary) rec += '<small>' + state.cm + ' cm is exactly where ' + m.boundary.k + ' ends and ' + m.size.k + ' starts, so ' + m.size.k + ' gives you room to adjust.</small>' + HELP;
      } else if (m.state === 'small') {
        rec = state.cm + ' cm is under our smallest size (XS starts at 33 cm). <a href="/collections/harnesses">See our other harnesses</a>' + HELP;
      } else if (m.state === 'large') {
        rec = state.cm + ' cm is over our largest size (XL fits up to 107 cm). <a href="/collections/harnesses">See our other harnesses</a>' + HELP;
      } else if (s) {
        rec = '<strong>' + s.name + '</strong> · Fits ' + s.min + ' to ' + s.max + ' cm';
      }
      if (autoNote && s) rec += '<small class="dlpb-autonote">' + autoNote + '</small>';
      recEl.innerHTML = rec;
      recEl.hidden = !rec;

      sizeButtons.forEach(function (b) {
        var k = b.getAttribute('data-size');
        b.setAttribute('aria-pressed', s && s.k === k ? 'true' : 'false');
        var out = !sizeHasStock(k);
        b.classList.toggle('is-out', out);
        b.setAttribute('aria-label', k + (out ? ', sold out' : ''));
      });
      (weightRows || []).forEach(function (r) {
        var k = r.getAttribute('data-size');
        r.setAttribute('aria-pressed', s && s.k === k ? 'true' : 'false');
        r.classList.toggle('is-out', !sizeHasStock(k));
      });
      swatches.forEach(function (b) {
        var c = b.dlpbColour;
        b.setAttribute('aria-checked', c === state.colour ? 'true' : 'false');
        var x = s ? variant(s.k, c) : null;
        var out = !!(s && (!x || !x.available));
        b.classList.toggle('is-out', out);
        b.setAttribute('aria-label', c + (out ? ', sold out in ' + s.k : ''));
      });
      colourNameEl.textContent = state.colour;

      /* summary */
      var l = currentLabel();
      summaryEl.classList.toggle('is-empty', !s);
      var saving = 0;
      if (!s) { summaryText.textContent = 'Choose a size above'; summaryPrice.textContent = 'From ' + money(minPrice); }
      else {
        var leadText = '';
        if (l.bundle) {
          var pair = leadPairs(l.offerNode)[0];
          leadText = ' + ' + (pair && pair.colour.value ? pair.colour.value + ' lead' : 'lead');
          if (l.original && l.cents && l.original > l.cents) saving = l.original - l.cents;
        }
        summaryText.textContent = s.k + ' · ' + state.colour + leadText;
        summaryPrice.textContent = money(l.cents || cents);
      }
      summaryEl.classList.toggle('is-bundle', saving > 0);
      if (saveEl) {
        saveEl.hidden = !saving;
        var saveText = saving ? 'You save ' + money(saving) : '';
        if (saveEl.textContent !== saveText) saveEl.textContent = saveText;
      }
      if (shipEl) shipEl.hidden = !(s && (l.cents || 0) >= FREE_SHIP_CENTS);
      if (upsellEl) {
        var up = (s && v && v.available && !l.bundle) ? bundleUpsell(v.price) : null;
        upsellEl.hidden = !up;
        if (up) {
          var mainText = 'Add the ' + (up.colour ? up.colour + ' ' : '') + 'lead for ' + money(up.add) + ' and save ' + money(up.save);
          var subText = (up.total >= FREE_SHIP_CENTS && v.price < FREE_SHIP_CENTS) ? 'Free shipping in Australia with the lead' : '';
          if (upsellMain.textContent !== mainText) upsellMain.textContent = mainText;
          if (upsellSub.textContent !== subText) upsellSub.textContent = subText;
        }
      }
      updatePhoto();
      gate();
    }

    if (upsellEl) upsellEl.addEventListener('click', function () {
      var v = state.selected ? variant(state.selected, state.colour) : null;
      var up = v ? bundleUpsell(v.price) : null;
      if (!up) return;
      (up.node.querySelector('.js-bx-offer-price') || up.node).click();
      setTimeout(render, 50);
    });

    /* Put the summary line right above the Add button, below the bundle offer */
    function placeSummary() {
      var form = info.querySelector('product-form');
      if (form && summaryEl.parentNode !== form) form.insertBefore(summaryEl, form.firstChild);
    }

    /* Sticky bar: shows when the main Add button is off screen */
    function buttonsBox() { return info.querySelector('.product-form__buttons') || submitButton(); }
    var stickyTicking = false;
    function updateSticky() {
      stickyTicking = false;
      var box = buttonsBox();
      if (!box || !sticky) return;
      var r = box.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      sticky.classList.toggle('is-visible', r.bottom < 0 || r.top > vh);
    }
    function onScroll() { if (!stickyTicking) { stickyTicking = true; (window.requestAnimationFrame || setTimeout)(updateSticky); } }
    if (sticky) {
      sticky.hidden = false;
      document.body.appendChild(sticky);
      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', onScroll);
      stickyBtn.addEventListener('click', function () {
        var l = currentLabel();
        if (!state.selected || l.disabled) {
          var target = !state.selected ? el('dlpb-size-step') : swWrap;
          var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({top: top, behavior: 'smooth'});
          return;
        }
        var btn = submitButton();
        if (btn && !btn.disabled) btn.click();
      });
    }

    /* Keep the label right when Dawn or Bundlex rewrite the button, and follow bundle offer changes */
    if (window.MutationObserver) {
      /* Bundlex can redraw its offer. Put the harness and lead picks back, with a cap so the two scripts can never loop. */
      var resyncTimer = null, resyncCount = 0, resyncWindow = 0;
      var scheduleBundleSync = function () {
        if (resyncTimer || !state.selected) return;
        resyncTimer = setTimeout(function () {
          resyncTimer = null;
          var now = Date.now();
          if (now - resyncWindow > 3000) { resyncWindow = now; resyncCount = 0; }
          if (++resyncCount > 6) return;
          syncBundleSelects();
        }, 60);
      };
      var mo = new MutationObserver(function () { if (!applyingLabel) { placeSummary(); render(); scheduleBundleSync(); } });
      var watch = function () {
        var btn = submitButton();
        if (btn) mo.observe(btn, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['disabled']});
        var w = bundleWidget();
        if (w && !w.__dlpbWatched) { w.__dlpbWatched = true; mo.observe(w, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class']}); syncBundleSelects(); }
      };
      watch();
      var tries = 0;
      var poll = setInterval(function () { watch(); placeSummary(); if (++tries > 20) clearInterval(poll); }, 500);
    }
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          if (!state.selected) { clearNativeSize(); dropVariantFromUrl(); }
          setTimeout(render, 0);
        });
      }
    } catch (err) {}
    function dropVariantFromUrl() {
      try {
        var url = new URL(window.location.href);
        if (!url.searchParams.has('variant')) return;
        url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (err) {}
    }

    placeSummary();
    if (!state.selected) clearNativeSize(); else syncNative();
    render();
    updateSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();